export default "__VITE_ASSET__BRWN_Yqf__"